export default {"src":"/_next/static/media/Status.im.6bfd95a2.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};